import { formatMoney } from "utils";

export const formatAmountMinor = (moneyAmount) => {
  if (!moneyAmount || moneyAmount.amountMinor === undefined || moneyAmount.amountMinor === null) {
    return formatMoney(0);
  }
  return formatMoney(Number(moneyAmount.amountMinor) / 100);
};
